import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CartService } from '../../../../shared/services/cart.service';
import { CartItem } from '../../../../shared/interfaces/cart-item';
import { RootService } from '../../../../shared/services/root.service';
import { OffcanvasCartService } from '../../../../shared/services/offcanvas-cart.service';
import { Cart2Service } from 'src/app/shared/services/cart2.service';
import { Angulartics2 } from 'angulartics2';

export type DropcartType = 'dropdown' | 'offcanvas';

@Component({
    selector: 'app-header-dropcart',
    templateUrl: './dropcart.component.html',
    styleUrls: ['./dropcart.component.scss']
})
export class DropcartComponent {
    removedItems: CartItem[] = [];

    @Input() type: DropcartType = 'dropdown';

    @Output() closeMenu: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        public state: OffcanvasCartService,
        public cart: CartService,
        public root: RootService,
        public cartService: Cart2Service,
    ) {
     }

    remove(item: CartItem): void {
        this.cartService.deleteRow(item.product['ItemGuid']).subscribe(res => {
        })
        if (this.removedItems.includes(item)) {
            return;
        }

        this.removedItems.push(item);
        this.cart.remove(item).subscribe({complete: () => this.removedItems = this.removedItems.filter(eachItem => eachItem !== item)});
    }

    close(): void {
        this.state.close();
    }
}
